import { ADDITIONAL_INFORMATION_TYPES } from '@savgroup-front-common/types';

export const isFileType = (neededInformation?: {
  type?: ADDITIONAL_INFORMATION_TYPES;
}) =>
  neededInformation?.type === ADDITIONAL_INFORMATION_TYPES.FILE ||
  neededInformation?.type === ADDITIONAL_INFORMATION_TYPES.MULTI_FILES;
